import React from 'react';
import './docsContact.scss';
import Button from "../../common/button/button";
import {navigate} from "gatsby";

const DocsContact = () => {
  const bookADemo = () => {
    navigate('/contact')
  }
  return (
    <div className='docs-contact-wrapper'>
      <div className='docs-contact-wrapper__docs-contact'>
        <div className='docs-contact-wrapper__docs-contact__text'>
          <p className='docs-contact-wrapper__docs-contact__text__title'>Have more questions?</p>
          <p className='docs-contact-wrapper__docs-contact__text__description'>If you face an issue, and cannot find an answer in the documentation, feel free to submit a support ticket!</p>
        </div>
        <Button
          type={'primary'}
          onClick={bookADemo}
          label='Contact us'
        />
      </div>
    </div>
  )
}

export default DocsContact